import React from "react";
import {NoticeTableHeader, NoticeTableRow, Paragraph, SectionHeading, SubHeading} from "../PrivacyPolicyText";

const NoticeAtCollectionSection = () => (
  <>
    <SubHeading>{"Notice at Collection"}</SubHeading>

    <Paragraph>
      {"Pursuant to California Civil Section 1798.100(b), this serves as notice of the categories of personal information that We collect through the Site and Services, the business or commercial purposes for which such personal information was collected, the categories of sources of such personal information, and the categories of third parties to whom such information was disclosed in the past twelve months."}
    </Paragraph>

    <NoticeTableHeader/>

    <NoticeTableRow category={"A. Identifiers."}>
      {"A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email address, account name, Social Security number, driver's license number, passport number, or other similar identifiers."}
    </NoticeTableRow>

    <NoticeTableRow
      category={"B. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e))."}>
      {"A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport number, driver's license or state identification card number, insurance Policy number, education, employment, employment history, bank account number, credit card number, debit card number, or any other financial information, medical information, or health insurance information. Some personal information included in this category may overlap with other categories."}
    </NoticeTableRow>

    <NoticeTableRow category={"C. Protected classification characteristics under California or federal law."}>
      {"Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic information)."}
    </NoticeTableRow>

    <NoticeTableRow category={"D. Commercial information."}>
      {"Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies."}
    </NoticeTableRow>

    <NoticeTableRow category={"E. Biometric information."}>
      {"Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data."}
    </NoticeTableRow>

    <NoticeTableRow category={"F. Internet or other similar network activity."}>
      {"Browsing history, search history, information on a consumer's interaction with a website, application, or advertisement."}
    </NoticeTableRow>

    <NoticeTableRow category={"G. Geolocation data."}>{"Physical location or movements."}</NoticeTableRow>

    <NoticeTableRow category={"H. Sensory data."}>
      {"Audio, electronic, visual, thermal, olfactory, or similar information."}
    </NoticeTableRow>

    <NoticeTableRow category={"I. Professional or employment- related information."}>
      {"Current or past job history or performance evaluations."}
    </NoticeTableRow>

    <NoticeTableRow
      category={"J. Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99))."}>
      {"Education records directly related to a student maintained by an educational institution or party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records."}
    </NoticeTableRow>

    <NoticeTableRow category={"K. Inferences drawn from other personal information."} withBottomMargin>
      {"Profile reflecting a person's preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes."}
    </NoticeTableRow>

    <SectionHeading>{"Changes to Our Privacy Policy"}</SectionHeading>

    <Paragraph>
      {"We reserve the right to amend this Privacy Policy at our discretion and at any time. When We make changes to this Privacy Policy, We will post the updated notice on the Website and update the notice's effective date. Your continued use of our Services following the posting of changes constitutes your acceptance of such changes."}
    </Paragraph>
  </>
);

export default NoticeAtCollectionSection;
